import { render, staticRenderFns } from "./StatsDetails.vue?vue&type=template&id=75af2f68&"
import script from "./StatsDetails.vue?vue&type=script&lang=js&"
export * from "./StatsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports